export const sortEmployeeRanges = (employees: string[]): string[] => {
  return employees.sort((a, b) => {
    // Always keep 'All' at the start
    if (a === 'All') return -1;
    if (b === 'All') return 1;

    // Put 'Unknown' at the end
    if (a.toLowerCase().includes('unknown')) return 1;
    if (b.toLowerCase().includes('unknown')) return -1;

    // Extract the first number from each range for comparison
    const getFirstNumber = (range: string) => {
      const match = range.match(/\d+/);
      return match ? parseInt(match[0], 10) : Infinity;
    };

    return getFirstNumber(a) - getFirstNumber(b);
  });
};

export const sortCategories = (categories: string[]): string[] => {
  return categories.sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
};
